import {
    CLEAR_PARTNERS,
    SET_PARTNERS,
    ADD_PARTNER,
    SET_ERRORS,
    CLEAR_ERRORS,
    MANAGE_LOADING_PARTNERS,
    MANAGE_EDITING_PARTNER } from './mutation-types.js';

function findMatchingPartnerListByType(partnersByType, partnerType) {

    const targetPartnersByTypeEntry = partnersByType.find(el => {
        return el.partnerType.id === partnerType.id;
    });
    if (!targetPartnersByTypeEntry) {
        console.error(`ERROR - no partners with partner type code [${partnerType.code}] and partner type id [${partnerType.id}] found`);
        return {
            partnerType: null,
            partners: []
        };
    }
    return targetPartnersByTypeEntry;
}

export default {
    [CLEAR_PARTNERS](state) {
        state.partnersByType = [];
    },
    [SET_PARTNERS](state, payload) {
        state.partnersByType.push(payload);
    },
    [ADD_PARTNER](state, payload) {
        const targetPartnersByTypeEntry = findMatchingPartnerListByType(state.partnersByType, payload.partnerType);
        if (targetPartnersByTypeEntry.partnerType) {
            targetPartnersByTypeEntry.partners.push(payload);
        } else {
            console.log(`ERROR IN ADD PARTNER - failed to add new partner [${payload.full_name}]`);
        }
    },
    [SET_ERRORS](state, payload) {
        state.errors = payload;
    },
    [CLEAR_ERRORS](state) {
        state.errors = null;
    },
    [MANAGE_LOADING_PARTNERS](state, payload) {
        state.loadingPartners = payload;
    },
    [MANAGE_EDITING_PARTNER](state, payload) {
        state.editingPartner = payload;
    }
}